import React from 'react';
import type { GroupElement } from '@/types';

interface GroupProps {
  element: GroupElement;
  isSelected: boolean;
}

export const Group: React.FC<GroupProps> = ({ element, isSelected }) => {
  const { x, y, width, height } = element;

  return (
    <g>
      {/* Group boundary - always visible but subtle when not selected */}
      <rect
        x={x}
        y={y}
        width={width}
        height={height}
        fill="transparent"
        stroke={isSelected ? "rgba(59, 130, 246, 0.8)" : "rgba(128, 128, 128, 0.3)"}
        strokeWidth="1"
        strokeDasharray="4 4"
        style={{ cursor: 'move' }}
      />
      
      {/* Show resize handles when selected */}
      {isSelected && (
        <g>
          {/* Selection border */}
          <rect
            x={x - 2}
            y={y - 2}
            width={width + 4}
            height={height + 4}
            fill="none"
            stroke="#007acc"
            strokeWidth={2}
            strokeDasharray="5,5"
          />
          {/* Resize handles */}
          {/* Top-left */}
          <rect x={x - 6} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Top-right */}
          <rect x={x + width - 2} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Bottom-left */}
          <rect x={x - 6} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Bottom-right */}
          <rect x={x + width - 2} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Top-center */}
          <rect x={x + width/2 - 4} y={y - 6} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Bottom-center */}
          <rect x={x + width/2 - 4} y={y + height - 2} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Left-center */}
          <rect x={x - 6} y={y + height/2 - 4} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
          {/* Right-center */}
          <rect x={x + width - 2} y={y + height/2 - 4} width={8} height={8} fill="#007acc" stroke="#ffffff" strokeWidth={1} />
        </g>
      )}
    </g>
  );
}; 